// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_staffing.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * SAD-500 SOL-04: a Pursuit's early staffing and LOE estimate. Append-only
 * revisions; the total is the sum of priced lines only and any unpriced line
 * makes the revision explicitly partial. An early estimate, never formal pricing.
 *
 * @generated from message mono.projectdata.v1.CaptureStaffingLine
 */ export class CaptureStaffingLine extends Message {
    static fromBinary(bytes, options) {
        return new CaptureStaffingLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureStaffingLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureStaffingLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureStaffingLine, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * person | role
   *
   * @generated from field: string subject_kind = 2;
   */ _define_property(this, "subjectKind", ""), /**
   * Canonical person key for a person line; empty for a role/LCAT placeholder.
   *
   * @generated from field: string subject_ref = 3;
   */ _define_property(this, "subjectRef", ""), /**
   * @generated from field: string subject_label = 4;
   */ _define_property(this, "subjectLabel", ""), /**
   * Hours x 100.
   *
   * @generated from field: int64 hours_centi = 5;
   */ _define_property(this, "hoursCenti", protoInt64.zero), /**
   * Absent = unpriced (never zero). USD cents per hour.
   *
   * @generated from field: optional int64 rate_cents = 6;
   */ _define_property(this, "rateCents", void 0), /**
   * observation | manual; empty when unpriced.
   *
   * @generated from field: string rate_source = 7;
   */ _define_property(this, "rateSource", ""), /**
   * delivery.rate_observations.id when rate_source is observation.
   *
   * @generated from field: string rate_observation_id = 8;
   */ _define_property(this, "rateObservationId", ""), /**
   * @generated from field: string rate_source_label = 9;
   */ _define_property(this, "rateSourceLabel", ""), /**
   * round(hours x rate) in cents; absent when unpriced.
   *
   * @generated from field: optional int64 amount_cents = 10;
   */ _define_property(this, "amountCents", void 0), /**
   * PRP-36: set by zou on a person line whose rate the caller may not see
   * (vault.person_rate.read). rate_cents, amount_cents, rate_observation_id and
   * rate_source_label are then cleared and a non-empty rate_source is "restricted".
   *
   * @generated from field: bool rate_restricted = 11;
   */ _define_property(this, "rateRestricted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureStaffingLine, "runtime", proto3);
_define_property(CaptureStaffingLine, "typeName", "mono.projectdata.v1.CaptureStaffingLine");
_define_property(CaptureStaffingLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subject_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "subject_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "subject_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "hours_centi",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "rate_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 7,
            name: "rate_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "rate_observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rate_source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "amount_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 11,
            name: "rate_restricted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureStaffingRevision
 */ export class CaptureStaffingRevision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureStaffingRevision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureStaffingRevision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureStaffingRevision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureStaffingRevision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int64 revision = 2;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string change_note = 3;
   */ _define_property(this, "changeNote", ""), /**
   * @generated from field: string currency = 4;
   */ _define_property(this, "currency", ""), /**
   * Sum over priced lines only.
   *
   * @generated from field: int64 loe_total_cents = 5;
   */ _define_property(this, "loeTotalCents", protoInt64.zero), /**
   * @generated from field: int32 priced_lines = 6;
   */ _define_property(this, "pricedLines", 0), /**
   * @generated from field: int32 unpriced_lines = 7;
   */ _define_property(this, "unpricedLines", 0), /**
   * @generated from field: bool is_partial = 8;
   */ _define_property(this, "isPartial", false), /**
   * @generated from field: string actor_user_id = 9;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureStaffingLine lines = 11;
   */ _define_property(this, "lines", []), /**
   * PRP-36: person lines that carried a rate and were redacted for this caller.
   *
   * @generated from field: int32 restricted_person_lines = 12;
   */ _define_property(this, "restrictedPersonLines", 0), /**
   * "all" | "role_lines_only"; "role_lines_only" means loe_total_cents sums role
   * lines only. Empty is "all".
   *
   * @generated from field: string total_scope = 13;
   */ _define_property(this, "totalScope", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureStaffingRevision, "runtime", proto3);
_define_property(CaptureStaffingRevision, "typeName", "mono.projectdata.v1.CaptureStaffingRevision");
_define_property(CaptureStaffingRevision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "loe_total_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "priced_lines",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "unpriced_lines",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_partial",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "lines",
            kind: "message",
            T: CaptureStaffingLine,
            repeated: true
        },
        {
            no: 12,
            name: "restricted_person_lines",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "total_scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureStaffingRequest
 */ export class GetCaptureStaffingRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureStaffingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureStaffingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureStaffingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureStaffingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureStaffingRequest, "runtime", proto3);
_define_property(GetCaptureStaffingRequest, "typeName", "mono.projectdata.v1.GetCaptureStaffingRequest");
_define_property(GetCaptureStaffingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureStaffingResponse
 */ export class GetCaptureStaffingResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureStaffingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureStaffingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureStaffingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureStaffingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Newest first.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureStaffingRevision revisions = 1;
   */ _define_property(this, "revisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureStaffingResponse, "runtime", proto3);
_define_property(GetCaptureStaffingResponse, "typeName", "mono.projectdata.v1.GetCaptureStaffingResponse");
_define_property(GetCaptureStaffingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revisions",
            kind: "message",
            T: CaptureStaffingRevision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureStaffingRevisionRequest
 */ export class SaveCaptureStaffingRevisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureStaffingRevisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureStaffingRevisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureStaffingRevisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureStaffingRevisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * The revision the caller edited from (0 for the first). A stale value is Aborted.
   *
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string change_note = 5;
   */ _define_property(this, "changeNote", ""), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureStaffingLine lines = 6;
   */ _define_property(this, "lines", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureStaffingRevisionRequest, "runtime", proto3);
_define_property(SaveCaptureStaffingRevisionRequest, "typeName", "mono.projectdata.v1.SaveCaptureStaffingRevisionRequest");
_define_property(SaveCaptureStaffingRevisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "lines",
            kind: "message",
            T: CaptureStaffingLine,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureStaffingRevisionResponse
 */ export class SaveCaptureStaffingRevisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureStaffingRevisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureStaffingRevisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureStaffingRevisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureStaffingRevisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureStaffingRevision revision = 1;
   */ _define_property(this, "revision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureStaffingRevisionResponse, "runtime", proto3);
_define_property(SaveCaptureStaffingRevisionResponse, "typeName", "mono.projectdata.v1.SaveCaptureStaffingRevisionResponse");
_define_property(SaveCaptureStaffingRevisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revision",
            kind: "message",
            T: CaptureStaffingRevision
        }
    ]));
